var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8636_48635)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8636_48635)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8636_48635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7676 10.9268C20.7676 5.40391 16.2904 0.926758 10.7676 0.926758C5.24473 0.926758 0.767578 5.40391 0.767578 10.9268C0.767578 16.4496 5.24473 20.9268 10.7676 20.9268C16.2904 20.9268 20.7676 16.4496 20.7676 10.9268Z",
    fill: "#FF9983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4349 7.42676L9.01823 13.8435L6.10156 10.9268",
    stroke: "#120A0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8636_48635"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.767578,
    y: 0.426758,
    width: 20,
    height: 21,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8636_48635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(0.767578 0.426758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8636_48635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(0.767578 0.426758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.b95fc25024260ef6fcb87677c4cbed39.svg";
export { ForwardRef as ReactComponent };